import { ca } from '@cian/analytics';

export const trackBuilderCallReasonsContactButtonClick = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_ask_builder',
    label,
    useLastProducts: true,
  });
};
